import React from 'react'
import loader from "../images/nes.gif"
import loading from "../images/load.gif"
import style from "./loading.module.css"

function Loading() {
  return (
    <div className={style.overlay}>
        <div className={style.modal}>
            <img src={loading} className={style.loading} alt="Loading videogame"/>
            <img src={loader} alt="Loading videogame"/>
        </div>
    </div>
  )
}

export default Loading